import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgMealNew = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask id="meal_new_svg__a" fill="#fff">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 2H4v4.5a3.5 3.5 0 0 0 1.802 3.062l-.641 9.943a2.344 2.344 0 1 0 4.678 0l-.641-9.943A3.5 3.5 0 0 0 11 6.5V2Z"
      />
    </mask>
    <path
      d="M4 2V1H3v1h1Zm7 0h1V1h-1v1ZM5.802 9.562l.998.064.041-.631-.553-.308-.486.875Zm-.641 9.943-.998-.064.998.064Zm4.678 0 .998-.064-.998.064Zm-.641-9.943-.486-.875-.553.308.04.63.999-.063ZM4 3h7V1H4v2Zm1 3.5V2H3v4.5h2Zm1.288 2.187A2.5 2.5 0 0 1 5 6.5H3c0 1.695.937 3.17 2.317 3.936l.971-1.749Zm-.13 10.883L6.8 9.626l-1.995-.129-.642 9.944 1.996.129ZM7.5 21a1.344 1.344 0 0 1-1.341-1.43l-1.996-.13A3.344 3.344 0 0 0 7.5 23v-2Zm1.341-1.43c.05.774-.565 1.43-1.341 1.43v2a3.344 3.344 0 0 0 3.337-3.56l-1.996.13ZM8.2 9.626l.641 9.944 1.996-.13-.642-9.943-1.995.129ZM10 6.5a2.5 2.5 0 0 1-1.288 2.187l.971 1.749A4.499 4.499 0 0 0 12 6.5h-2ZM10 2v4.5h2V2h-2Z"
      fill="#4D4D4D"
      mask="url(#meal_new_svg__a)"
    />
    <path
      d="M19.5 16v.5h.5V16h-.5Zm-2.323 0v-.5h-.53l.03.53.5-.03Zm.232 3.959-.499.029.5-.03ZM14.5 2.5V2H14v.5h.5ZM20 16V8h-1v8h1Zm-2.823.5H19.5v-1h-2.323v1Zm-.5-.47.233 3.958.998-.059-.232-3.958-.999.058Zm.233 3.958A.956.956 0 0 1 15.956 21v1a1.956 1.956 0 0 0 1.953-2.07l-.999.058ZM15.956 21a.956.956 0 0 1-.956-.956h-1c0 1.08.876 1.956 1.956 1.956v-1ZM15 20.044V16h-1v4.044h1ZM15 16V4.5h-1V16h1ZM14 2.5v2h1v-2h-1ZM20 8c0-3.211-2.163-6-5.5-6v1C17.163 3 19 5.211 19 8h1Z"
      fill="#4D4D4D"
    />
    <path d="M6.5 2.5v4M8.5 2.5v4" stroke="#4D4D4D" />
  </svg>
);
const Memo = memo(SvgMealNew);
export default Memo;
